import React from 'react';

const menuItems = [
  { id: 'notas', icon: '📊', text: 'Sistema de notas', requiresAuth: true, allowedRoles: ['admin', 'teacher'] },
  { id: 'frequencia', icon: '✅', text: 'Frequência escolar', requiresAuth: true, allowedRoles: ['admin', 'teacher'] },
  { id: 'calendario', icon: '📅', text: 'Calendário escolar', requiresAuth: true, allowedRoles: ['admin', 'teacher', 'student'] },
  { id: 'relatorios', icon: '🤖', text: 'Relatórios por IA', requiresAuth: true, allowedRoles: ['admin', 'teacher'] },
  { id: 'organizacao', icon: '👨‍🏫', text: 'Organização do Professor', requiresAuth: true, allowedRoles: ['admin', 'teacher'] },
  { id: 'cronograma', icon: '📋', text: 'Cronograma escolar', requiresAuth: true, allowedRoles: ['admin', 'teacher', 'student'] },
  { id: 'turmas', icon: '👥', text: 'Turmas', requiresAuth: true, allowedRoles: ['admin', 'teacher', 'student'] },
  { id: 'atividades', icon: '📝', text: 'Atividades', requiresAuth: true, allowedRoles: ['admin', 'teacher', 'student'] },
  { id: 'boletins', icon: '📄', text: 'Boletins', requiresAuth: true, allowedRoles: ['admin', 'teacher', 'student'] },
  { id: 'simulados', icon: '📚', text: 'Simulados', requiresAuth: true, allowedRoles: ['admin', 'teacher', 'student'] },
  { id: 'inmessage', icon: '💬', text: 'InMessage', requiresAuth: true, allowedRoles: ['admin'] }
];

const Sidebar = ({ isOpen, currentPage, onMenuClick, isAuthenticated, userRole = null }) => {
  const handleClick = (e, itemId) => {
    e.preventDefault();
    const rect = e.currentTarget.getBoundingClientRect();
    onMenuClick(itemId, {
      x: rect.left + rect.width / 2,
      y: rect.top + rect.height / 2
    });
  };

  const isItemDisabled = (item) => {
    if (!item.requiresAuth) return false;
    if (!isAuthenticated) return true;
    if (!userRole) return true;
    return !item.allowedRoles.includes(userRole);
  };

  return (
    <aside className={`sidebar ${!isOpen ? 'collapsed' : ''}`}>
      <nav className="menu">
        <ul className="menu-list">
          {menuItems.map((item, index) => (
            <li key={item.id} className="menu-item" style={{ animationDelay: `${index * 0.1}s` }}>
              <a
                href="#"
                className={`menu-link ${currentPage === item.id ? 'active' : ''} ${isItemDisabled(item) ? 'disabled' : ''}`}
                onClick={(e) => !isItemDisabled(item) && handleClick(e, item.id)}
                style={{ animationDelay: `${index * 0.05}s` }}
              >
                <span className="menu-icon">{item.icon}</span>
                <span className="menu-text">{item.text}</span>
              </a>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;
